import { useState, useEffect } from "react";
import type { ReactNode } from "react";
import { MenuIcon, CloseIcon } from "../../../shared/crm/components/icons/Icon";
import "./CRMLayout.scss";

interface CrmLayoutProps {
  sidebar: ReactNode;
  header: ReactNode;
  children: ReactNode;
}

function CRMLayout({ sidebar, header, children }: CrmLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen((previous) => !previous);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isSidebarOpen]);

  return (
    <div
      className={`crm-layout ${isSidebarOpen ? "crm-layout--sidebar-open" : ""}`}
    >
      <aside className="crm-layout__sidebar">
        <div className="crm-layout__sidebar-header">
          {sidebar}
          <button
            type="button"
            className="crm-layout__toggle crm-layout__toggle--close"
            onClick={toggleSidebar}
            aria-label="CRM-Navigation schließen"
          >
            <CloseIcon />
          </button>
        </div>
      </aside>

      {isSidebarOpen && (
        <div className="crm-layout__overlay" onClick={toggleSidebar} />
      )}

      <div className="crm-layout__main">
        <header className="crm-layout__header">
          {header}
          <button
            type="button"
            className="crm-layout__toggle"
            onClick={toggleSidebar}
            aria-label="CRM-Navigation öffnen"
          >
            <MenuIcon />
          </button>
        </header>
        <div className="crm-layout__content">
          <div className="crm-layout__content-main">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CRMLayout;
